import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-no-data',
  templateUrl: './status-no-data.component.html',
  styleUrls: ['./status-no-data.component.css']
})
export class StatusNoDataComponent implements OnInit {

  @Input()
  show: boolean;

  @Input()
  text = 'No Data Found!';

  @Input()
  textColor = '#f6a608';

  @Input()
  addPadding = true;

  styles = {
    'color': '#f6a608'
  };

  ngOnInit(): void {
    if (this.textColor) {
      this.styles.color = this.textColor;
    }
  }

}
